import { Paper, Stack, Typography } from "@mui/material";
import olMap from 'ol/Map';
import VectorImageLayer from "ol/layer/VectorImage";
import VectorSource from "ol/source/Vector";
import { useContext, useEffect, useRef } from "react";
import $map from "../../services/$map";
import { basemaps } from "../../config/map";
import { AppContext } from "../../AppContext";
import { DataContext } from "../DataContext";

function ParcelMap({ parcel }) {
  const {selected} = useContext(AppContext);
  const {projectData} = useContext(DataContext);
  const mapElement = useRef(null);

  useEffect(() => {
    const map = new olMap({
      target: mapElement.current,
      interactions: [],
      layers: [
        basemaps('sat')[0],
        new VectorImageLayer({
          style: $map.featureStyle,
          source: new VectorSource({
            features: [parcel.feature]
          })
        })
      ]
    })

    map.getView().fit(parcel.feature.getGeometry().getExtent(), {
      padding: [50, 50, 50, 50],
    })

    return () => {
      map.setTarget(null);
    }
  }, [])

  return <Paper ref={mapElement} elevation={5} sx={{ position: 'relative', height: '220px', width: '100%' }}>
    <Paper className="co-background" sx={{ position: 'absolute', top: 0, left: 0, zIndex: 3, padding: '10px', borderRadius: 0, whiteSpace: 'nowrap' }}>
      <Stack>
        <Typography textAlign="left" component="span" sx={{ display: 'inline' }}>Farm: <Typography sx={{ display: 'inline' }} fontWeight="bold" color="primary">{parcel.project?.name}</Typography></Typography>
        <Typography textAlign="left" component="span" sx={{ display: 'inline' }}>Name: <Typography sx={{ display: 'inline' }} fontWeight="bold" color="primary">{parcel.name}</Typography></Typography>
        <Typography textAlign="left" component="span" sx={{ display: 'inline' }}>Area: <Typography sx={{ display: 'inline' }} fontWeight="bold" color="primary">{parcel.area.toFixed(2)} ha</Typography></Typography>
      </Stack>
    </Paper>
  </Paper>
}

export default ParcelMap;